import { meta } from '@eslint/js';
import axios from 'axios';


export const fetchDataAPI = async( url, entity, config = null ) => {
    let rsp = null;
    let isError = false;

    try {
        const axiosResult = await axios.post(url, entity, config);
        
        if (axiosResult.data !== null){

            const { code, message, metadata } = axiosResult.data;

            isError = ( code === '00' ? false : true );
            rsp = {
                code: code,
                message: message,
                metadata: metadata,
                loading: false,
                isError: isError,
                httpCode: 200
            };
        }
        else{
            rsp = {
                code: '01',
                message: null,
                metadata: null,
                loading: false, 
                isError: isError,
                httpCode: 1
            }
        }
    } catch (error) {
        rsp = {
            code: '01',
            message: error.message,
            metadata: null,
            loading: false, 
            isError: true,
            httpCode: `${error.response?.status}`
        }
    }


    if (rsp.httpCode === '401'){
        window.localStorage.removeItem("reduxState");
        location.href = "/home?msg=err401";
        return null;
    }
    else
        return rsp;
}

